var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMascotSmall1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "4 4 44 44",
    fill: "#E48A99",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_74_24538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 48C38.1503 48 48 38.1503 48 26C48 13.8497 38.1503 4 26 4C13.8497 4 4 13.8497 4 26C4 38.1503 13.8497 48 26 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 48C38.1503 48 48 38.1503 48 26C48 13.8497 38.1503 4 26 4C13.8497 4 4 13.8497 4 26C4 38.1503 13.8497 48 26 48Z",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7646 9.07433C19.1862 9.88685 17.978 16.9101 18.0008 19.2321C17.9992 20.347 18.2857 21.447 18.8379 22.4458C19.39 23.4447 20.1928 24.3152 21.1832 24.989V36.2098L18.3947 37.3975C18.2165 37.5057 18.0876 37.6677 18.0313 37.8539C17.975 38.0402 17.9951 38.2383 18.0879 38.4124C18.1807 38.5865 18.34 38.725 18.537 38.8027C18.7339 38.8803 18.9554 38.8921 19.1612 38.8357L24.5295 37.4598C24.6714 37.453 24.8076 37.4075 24.9198 37.3293C25.032 37.2511 25.1148 37.144 25.1572 37.0224C25.2 36.7524 24.8578 36.3877 24.3195 36.3972V26.2962C25.4447 26.5178 26.6095 26.5226 27.7369 26.3102V40.3387L24.9483 41.5264C24.77 41.6346 24.6409 41.7966 24.5845 41.9829C24.5282 42.1693 24.5483 42.3676 24.6412 42.5418C24.7341 42.716 24.8936 42.8544 25.0908 42.932C25.2879 43.0096 25.5096 43.0212 25.7154 42.9646L31.0837 41.5886C31.2255 41.5819 31.3616 41.5363 31.4738 41.4582C31.5859 41.38 31.6686 41.2728 31.7108 41.1512C31.7536 40.8812 31.4114 40.5171 30.8731 40.526V27.4564C30.8731 26.3694 30.8731 25.3292 30.8731 25.0373C32.259 24.1374 33.2754 22.8529 33.765 21.3827C34.1921 19.8208 34.034 18.1762 33.3151 16.7029C32.008 13.4931 28.0202 8.3191 23.7646 9.07433ZM20.1761 18.3319L20.2189 17.6464L24.7184 13.5978L25.4077 13.5689L26.1254 13.9813L27.7557 19.4971L27.4264 20.0561L26.7042 20.3849L20.565 18.8933L20.1761 18.3319Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3934 18.8283C25.4714 18.8283 26.3454 18.0446 26.3454 17.0777C26.3454 16.1109 25.4714 15.3271 24.3934 15.3271C23.3153 15.3271 22.4414 16.1109 22.4414 17.0777C22.4414 18.0446 23.3153 18.8283 24.3934 18.8283Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_74_24538",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.362353 0 0 0 0 0.418353 0 0 0 0 0.54902 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_74_24538"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_74_24538",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMascotSmall1);
export default __webpack_public_path__ + "static/media/mascot_small_1.a98939f9a6784fd7f0b789d4004e46c3.svg";
export { ForwardRef as ReactComponent };